import classNames from 'classnames';
import * as React from 'react';
import { useRef } from 'react';

import { useExperimentAwareUrl } from '../../../Experimentation/Components/ResolveExperimentId';
import { renderInfoLabel } from '../../../ReactComponents/InfoLabel/InfoLabel';
import { ResponsivePicture } from '../../../ReactComponents/ResponsivePicture/ResponsivePicture';
import { withPromotionImpression } from '../../../Tracking/GoogleTagManager/PromotionImpression/WithPromotionImpression';
import { DiscountVariant } from '../../DiscountVariant.csharp';
import { hasLineBreak } from '../../TextUtils';
import { ImageBannerProps } from './ImageBannerProps.csharp';

function ImageBanner(props: ImageBannerProps) {
    const { profile, model } = props;

    const contentRef = useRef(null);

    const link = useExperimentAwareUrl(model.link, contentRef);

    return (
        <div ref={contentRef} className="ImageBanner">
            <a href={link} target={model.openInNewTab ? '_blank' : '_self'} rel="noreferrer">
                <div className="ImageBanner__Picture">
                    {model.image && <ResponsivePicture profile={profile} model={model.image} isLazyLoaded={model.isLazyLoaded} />}
                </div>

                {model.heading && (
                    <h2 className={classNames('ImageBanner__Heading', hasLineBreak(model.heading) && 'ImageBanner__Heading--LineBreak')}>
                        <span>{model.heading}</span>
                    </h2>
                )}

                {renderInfoLabel(model.discount, DiscountVariant.Small, model.label)}
            </a>
        </div>
    );
}

export default withPromotionImpression(ImageBanner);
